import React, {useImperativeHandle, useRef} from "react";
import Login from "../login/login";
import SignIn from "../signin/signin";
import ForgotPassword from "../forgotPassword/forgotPassword";
import {FormattedMessage} from "react-intl";
import {CustomModal} from "../../shared";
import users from "../index";
import {useDispatch, useSelector} from "react-redux";

const LoginHome = React.forwardRef((props, ref) => {

    const dispatch = useDispatch();

    const buttonOpenLoginModal = useRef();
    const closeModalButton = useRef();
    const currentPage = useSelector(users.selectors.getCurrentLoginPage)

    function openModal(page = "login") {
        dispatch(users.actions.setCurrentLoginPage(page));
        buttonOpenLoginModal.current.click();
    }

    useImperativeHandle(ref, () => ({
        // Method to save the role that is being edited
        openModal: (page = "login") => {
            return openModal(page);
        },
    }));

    function closeModal() {
        closeModalButton.current.click();
    }

    function setCurrentPage(page) {
        dispatch(users.actions.setCurrentLoginPage(page));
    }

    return (
        <div>
            <CustomModal modalName="loginUserModal" modalClasses="modal-lg"
                         content={<div>
                             <button type="button" style={{display: 'none'}} data-bs-dismiss="modal"
                                     aria-label="Close" ref={closeModalButton}></button>
                             <div className="modal-header d-flex flex-row flex-wrap justify-content-center">
                                 {currentPage === "login" &&
                                     <h3 className="modal-title"><FormattedMessage id="users.login.log-in"/></h3>}
                                 {currentPage === "signUp" &&
                                     <h3 className="modal-title"><FormattedMessage id="users.login.sign-up"/></h3>}
                                 {currentPage === "recoverPass" &&
                                     <h3 className="modal-title"><FormattedMessage id="users.recover-password.title"/>
                                     </h3>}
                                 <button type="button" className="btn-close" onClick={closeModal}></button>
                             </div>
                             <div className="modal-body">
                                 {currentPage === "login" &&
                                     <Login setCurrentPage={setCurrentPage} onFinishLogin={closeModal}/>}
                                 {currentPage === "signUp" &&
                                     <SignIn setCurrentPage={setCurrentPage} onFinishLogin={closeModal}/>}
                                 {currentPage === "recoverPass" &&
                                     <ForgotPassword setCurrentPage={setCurrentPage} onFinishLogin={closeModal}/>}
                             </div>
                             <div className="modal-footer">
                                 <button type="button" className="btn btn-secondary" onClick={closeModal}>
                                     <FormattedMessage id="modal.cancel"/>
                                 </button>
                             </div>
                         </div>}/>
            <button hidden={true} data-bs-toggle="modal" data-bs-target="#loginUserModal"
                    ref={buttonOpenLoginModal}>
            </button>
        </div>
    )
});

export default LoginHome;
